import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Divider, List, message } from "antd";
import { withRouter } from "react-router-dom";
import { apiCallback } from "../../ApiHandlers/Common";
import { convertServiceSimpleList } from "../../Helpers/ServiceHelpers";
import { BreadCrumbs } from "../Common/BreadCrumbs";

class ServiceSimpleList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      serviceData: [],
      serviceDataLoading: false,
    };
  }

  componentDidMount() {
    this.updateServiceList();
  }

  updateServiceList() {
    console.log("updateServiceList...");
    const {
      history,
      serviceApi,
      deviceEntitlementApi,
      deviceRecord,
      serviceProviderRecord,
    } = this.props;
    this.setState({ serviceDataLoading: true });
    const errorCallback = () => {
      this.setState({ serviceDataLoading: false });
      message.error("Error fetching Service list");
    };
    const successCallback = (data) => {
      const serviceData = convertServiceSimpleList(data);
      console.log("updateServiceList data", serviceData);
      this.setState({ serviceData, serviceDataLoading: false });
    };
    try {
      if (serviceProviderRecord) {
        serviceApi.getServiceByProviderId(
          serviceProviderRecord.providerId,
          apiCallback({ history, errorCallback, successCallback })
        );
      } else if (deviceRecord) {
        deviceEntitlementApi.getDeviceentitlementById(
          deviceRecord.deviceId,
          apiCallback({
            history,
            errorCallback,
            successCallback: (data) => {
              const serviceData = data.services?.split(",") || [];
              console.log("updateServiceList data", serviceData);
              this.setState({ serviceData, serviceDataLoading: false });
            },
          })
        );
      } else {
        throw new Error("Parent record not found!");
      }
    } catch (error) {
      errorCallback();
    }
  }

  getParentEntityTitle = () => {
    const { serviceProviderRecord, deviceRecord } = this.props;
    return serviceProviderRecord
      ? `Service Provider: ${serviceProviderRecord.name}`
      : deviceRecord
      ? `Device: ${deviceRecord.deviceId}`
      : null;
  };

  render() {
    const { onParentActionClick, parentBread } = this.props;
    const { serviceData, serviceDataLoading } = this.state;
    const parentEntityTitle = this.getParentEntityTitle();

    return (
      <div className="service-list-container">
        <div className="page-header-container">
          <BreadCrumbs
            headers={parentBread.concat("Service List")}
            onParentActionClick={onParentActionClick(null, null)}
          />
        </div>
        <Divider className="divider" />
        {parentEntityTitle && (
          <div className="page-parent-title-container">
            <label>{parentEntityTitle}</label>
          </div>
        )}
        <div className="service-simple-list">
          <List
            bordered
            dataSource={serviceData}
            loading={serviceDataLoading}
            renderItem={(item) => (
              <List.Item>{item.serviceName || item}</List.Item>
            )}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  serviceApi: state.apis.serviceApi,
  deviceEntitlementApi: state.apis.deviceEntitlementApi,
});

const connectedServiceSimpleList = connect(mapStateToProps)(ServiceSimpleList);

ServiceSimpleList.propTypes = {
  serviceProviderRecord: PropTypes.object,
  deviceRecord: PropTypes.object,
  onParentActionClick: PropTypes.func,

  serviceApi: PropTypes.object,
  deviceEntitlementApi: PropTypes.object,
};

export default withRouter(connectedServiceSimpleList);
